import { DocsBlockPropertyDefinition, } from "./SDKDocsBlockProperty";
/** Number property - Definition */
export class DocsBlockNumberPropertyDefinition extends DocsBlockPropertyDefinition {
}
